import { createSelector } from 'reselect';

import { sortBuckets } from '../utils/sort';

export const getBucketList = createSelector(
    (state) => {
        return state?.storageBuckets?.Buckets || [];
    },
    (list) => sortBuckets(list),
);
